import ProjectHero from './ProjectHero';

export default ProjectHero;
